import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { first, map, switchMap } from 'rxjs/operators';
import { UserData } from '../models/identity/user-data';
import { Observable } from 'rxjs';
import { UserpilotService } from './userpilot.service';
import { SecurityService } from './security.service';

@Injectable()
export class SecurityGuardService  {

    storage: Storage;
    state?: RouterStateSnapshot;

    constructor(private router: Router, private securityService: SecurityService, private userPilotService: UserpilotService) {
        this.storage = sessionStorage;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        this.state = state;
        return this.securityService.isAuthenticated().pipe(switchMap(isAuthenticated => {
            if (!isAuthenticated) {
                return this.router.navigate(['/login']);
            }
            
            return this.securityService.getUserData().pipe(map(res => {
                Object.setPrototypeOf(res, UserData.prototype);
                if (!res || !res.hasAccess()) {
                    this.router.navigate(['/unauthorized']);
                    return false;
                }
                this.userPilotService.reload();
                return true;
            }));
        }), first());
    }
}
